import React from 'react';
import FullStackDeveloper from '../../templates/careers/fullStackDeveloper';

const SeniorFullStackDeveloper = () => (
  <FullStackDeveloper />
);

export default SeniorFullStackDeveloper;
